import React, { useEffect, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import './AuthForms.css';

const OAuthCallback: React.FC = () => {
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const { setToken, setUser, setIsAuthenticated, setIsAdmin } = useContext(AuthContext) as any;

  useEffect(() => {
    // This component is now a fallback in case the server-side redirect doesn't work
    // The server should have already stored the token and user in localStorage
    const token = localStorage.getItem('token');
    const userJson = localStorage.getItem('user');
    
    if (token && userJson) {
      try {
        const user = JSON.parse(userJson);
        
        // Set auth context
        setToken(token);
        setUser(user);
        setIsAuthenticated(true);
        setIsAdmin(user.role === 'admin');
        
        // Redirect to dashboard
        navigate('/dashboard');
      } catch (err: any) {
        console.error('Error parsing user JSON:', err);
        setError('Authentication data is invalid. Please try again.');
      }
    } else {
      // No token or user, show error
      setError('Authentication failed. Please try again.');
    }
  }, [navigate, setToken, setUser, setIsAuthenticated, setIsAdmin]);

  if (error) {
    return (
      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-header">
            <h1>Authentication Error</h1>
          </div>
          
          <div className="auth-error">
            <p>{error}</p>
          </div>
          
          <div className="auth-footer">
            <button 
              className="submit-button"
              onClick={() => navigate('/login')}
            >
              Back to Login
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h1>Authenticating</h1>
          <p>Please wait while we complete your authentication...</p>
        </div>
        
        <div className="loading-container">
          <div className="loading-spinner large"></div>
        </div>
      </div>
    </div>
  );
};

export default OAuthCallback; 